import { VOICE_AUTH_TYPE } from "@/constants/voice";

const DEFAULT_SPEAKER = {
        "id": 416,
        "wwid": "15a9c73845d04424a316ff0cff16f49f",
        "speaker": "m091_lpcnet_24k",
        "name": "魔天轮",
        "headerImage": "https://mobvoi-backend-public.ticwear.com/headerImage/png/9241b691-72b7-44a5-947b-dcd1b050613c2x.png",
        "introduction": "",
        "characteristic": "",
        "vipAuth": VOICE_AUTH_TYPE.SVIP,
        "level": "open",
        "age": "ADULT",
        "specificAge": 30,
        "specificLanguage": "普通话",
        "gender": "MALE",
        "createdAt": "2020-01-14T13:46:00.000+0800",
        "updatedAt": "2021-04-26T09:07:30.000+0800",
        "limitFree": false,
        "tags": "热门",
        "pauseMap": "break_prosody,phrase_prosody",
        "vcSpeaker": "m091_24k_vc",
        "likeCount": 0,
        "playCount": 613,
        "followerCount": 0,
        "priceRate": 0,
        "status": "AVAILABLE",
        "version": null,
        "displayOrder": 30,
        "top": 0,
        "source": "问问内部",
        "boutique": null,
        "language": "MANDARIN_CHINESE",
        "speakerSpeed": 5.2,
        "speakerFeature": [
            {
                "id": 5,
                "name": "音标"
            },
            {
                "id": 6,
                "name": "局部变速"
            },
            {
                "id": 7,
                "name": "多发音人"
            },
            {
                "id": 8,
                "name": "停顿调节"
            },
            {
                "id": 9,
                "name": "插入静音"
            },
            {
                "id": 10,
                "name": "特效音"
            },
            {
                "id": 11,
                "name": "背景音"
            },
            {
                "id": 12,
                "name": "全局段落静音"
            },
            {
                "id": 13,
                "name": "儿化音"
            },
            {
                "id": 14,
                "name": "变调"
            },
            {
                "id": 15,
                "name": "符号静音"
            },
            {
                "id": 16,
                "name": "全文停顿调节"
            },
            {
                "id": 18,
                "name": "查找替换-多音字"
            },
            {
                "id": 19,
                "name": "重读"
            },
            {
                "id": 0,
                "name": "试听"
            },
            {
                "id": 1,
                "name": "多音字"
            },
            {
                "id": 2,
                "name": "数字符号"
            },
            {
                "id": 3,
                "name": "连读"
            },
            {
                "id": 4,
                "name": "别名"
            }
        ],
        "speakerType": [
            {
                "id": 9,
                "name": "影视解说",
                "createdAt": "2020-01-01T00:30:00.000+0800",
                "updatedAt": "2020-11-09T19:07:50.000+0800",
                "speakers": null
            }
        ],
        "usable": true,
        "styleName": "通用",
        "styleAvatar": "https://mobvoi-backend-public.ticwear.com/headerImage/png/9241b691-72b7-44a5-947b-dcd1b050613c2x.png"
};
export default class PageState {
    //模板生成============================================================================
    self: any = null;
    title: string = "";
    //============================================================================
    ww_token: string = '';
    // 是否登录
    isLogined: boolean = false;
    // 是否已提示
    hasBeenRemind:boolean = false;
    // 发音人类型
    speakerTypeList: any = [];
    // 发音人相关初始map
    allSpeakerIdMap: any = {};
    allSpeakerIds: any = [];
    allSpeakersMap: any = {};
    alLineSpeakerMap: any = {};
    allStoreSpeakers: any = [];
    defaultSpeakerIds: any = [];
    typeSpeakerMap: any = [];
    userSpeakerList: any = [];
    vcSpeakerList: any = [];
    searchTagList:any= []; //选择发音人时的查询列表
    userHasSpeakersMap:any=[];
    historySpeakers:any=[];//历史发音人
    userSpeakerTypeMapList:any=[];//用户发音分类(常用/已购/收藏..)
    languageList: any = []; //所有语言
    nameToEngNameMap:any=[];//发音人名称和英文名字映射关系
    // 计算后发音人map
    speakerList: any = [];
    // 风格Map
    emotionListMap: any = {};

    // 文章id
    articleId: string = '';

    // 试听来源参数
    AUDITION_PRODUCT: string = 'mini_program';
    // ios是否可以购买
     //目前ios都不可以购买-考虑删除
    // canIosBuyVoice: boolean = false;

    currentSpeakerListId: any = '';

    // 基础默认发音人
    baseDefaultSpeaker:any = DEFAULT_SPEAKER;
    
    // 当前选中发音人
    currentSelectSpeaker: any = DEFAULT_SPEAKER;
    // 发音人弹窗
    speakerPopupVisible: boolean = false;
    // 引导购买弹窗
    buyVoicePopupVisible: boolean = false;
    // 当前需要购买的发音人
    selectPaySpeaker: any = null;

    // 试听限制
    auditionLimit: boolean = false;
    // 是否有下一句
    hasNextAudition: boolean = false;

    // 语音index
    auditionIndex: number = 0;
    // 语音数组
    auditionArr: any = [];
    // 播放id
    playId: string | null = null;
    // oss远程地址
    audioUrl: string = '';
    // 播放合成音频每句的时间信息
    audioDurationInfoPerSentence: any = [];
    // 字幕地址
    subtitleUrl: string = '';
    // ossFile对象
    audioOssFile: any = null;

    transactionId: string = '';
    // 是否合成
    isComposed: boolean = false;
    // 价格弹窗
    priceModal: boolean = false;

    articleTxt: any[] = [];
    content: string = '';
    originContent: string = '';
    originSpeaker: any = '';
    originSpeed: any = '';
    originPitch: any = '';
    speedSlideIndex: any = 18;
    pitchSlideIndex: any = 10;
    speedSlideVal: any = '1.0';
    pitchSlideVal: any = '0';
    originEmotionWeight: number = 1;
    emotionWeight: number = 1;
    speedIndex: any = '';
    pitchIndex: any = '';
    vipInfo: any = '';
    priceData: any = '';

    // 专辑
    companyList: any = [];
    // 专辑index
    companyId: any = 0;
    isWeta365: boolean = false;
    isAixiaomoEditor: boolean = false;
    //aixiaomo弹框
    abandonShow: boolean = false;
}

